import {
  CLEAR_ACTIVE_FILTERS,
  CLEAR_CUSTOMIZATION_CONFIGS,
  CLEAR_PERIODIC_PREFERENCES,
  DELETE_REPORT,
  GET_FORMS_PRIORITIES,
  GET_OBSERVATIONS_PRIORITIES,
  GET_REPORTS_LIST,
  SCHEDULE_REPORT,
  SET_ACTIVE_FILTERS,
  SET_CUSTOMIZATION_CONFIGS,
  SET_FORMS_PRIORITIES,
  SET_LOADING_FLAG,
  SET_OBSERVATIONS_PRIORITIES,
  SET_PERIODIC_PREFERENCES,
  SET_RECIPIENTS_PREFERENCES,
} from './constants';

export function setLoadingFlag(loading) {
  return {
    type: SET_LOADING_FLAG,
    loading,
  };
}

export function getFormsPriorities() {
  return {
    type: GET_FORMS_PRIORITIES,
  };
}

export function setFormsPriorities(priorities) {
  return {
    type: SET_FORMS_PRIORITIES,
    priorities,
  };
}
export function getObservationsPriorities() {
  return {
    type: GET_OBSERVATIONS_PRIORITIES,
  };
}

export function setObservationsPriorities(priorities) {
  return {
    type: SET_OBSERVATIONS_PRIORITIES,
    priorities,
  };
}

export function setRecipientsPreferences(recipient_ids, id) {
  return {
    type: SET_RECIPIENTS_PREFERENCES,
    id,
    recipient_ids,
  };
}

export function setActiveFilters(filters) {
  return {
    type: SET_ACTIVE_FILTERS,
    filters,
  };
}

export function scheduleReport(callback, listsRequestOption, id) {
  return {
    type: SCHEDULE_REPORT,
    id,
    callback,
    listsRequestOption,
  };
}

export function setPeriodicReportPreferences(periodicReportPreferences) {
  return {
    type: SET_PERIODIC_PREFERENCES,
    periodicReportPreferences,
  };
}
export function clearPeriodicReportPreferences() {
  return {
    type: CLEAR_PERIODIC_PREFERENCES,
  };
}

export function clearActiveFilters() {
  return {
    type: CLEAR_ACTIVE_FILTERS,
  };
}

export function getReportsList() {
  return {
    type: GET_REPORTS_LIST,
  };
}

export function deleteReport(reportId, idData, callback) {
  return { type: DELETE_REPORT, reportId, idData, callback };
}

export function setCustomizationConfigs(configs, id) {
  return {
    type: SET_CUSTOMIZATION_CONFIGS,
    configs,
    id,
  };
}

export function clearCustomizationConfigs(id) {
  return {
    type: CLEAR_CUSTOMIZATION_CONFIGS,
    id,
  };
}
